export default "__VITE_ASSET__e6c4b84f__"